export default __webpack_public_path__ + "static/media/memorial2023.1922e901.pdf";